import { useTranslation } from "react-i18next";
import { User } from "../../services/user/userModel";
import { userService } from "../../services/user/userService";
import { useState } from "react";
import { loggerBuilder } from "../../services/logger";
import { toastsWithIntl } from "../../services/toastService";
import CandidateIcon from "../candidate/CandidateIcon";

const PremiumSection = ({ user }: { user: User }) => {
  const { getCustomerPortalUserLink } = userService();
  const { t } = useTranslation();
  const logger = loggerBuilder("PremiumSection");
  const { toastError } = toastsWithIntl(["common"]);
  const [loadingPortal, setLoadingPortal] = useState(false);
  return (
    <section className="ui-card --pad cand-card">
      <div className="cand-card_head">
        <h2 className="ui-st">{t("accounts:premium.SECTION_TITLE")}</h2>
        <span className="ui-chip --prem">
          <CandidateIcon name="bolt" />
          {t("accounts:premium.BADGE")}
        </span>
      </div>
      <div className="cand-card_body">
        <p className="ui-muted">{t("accounts:premium.SECTION_SUBTITLE")}</p>
        {user.subscriptionEndDate && (
          <p className="ui-small">
            {t("accounts:premium.UNTIL", {
              date: new Date(user.subscriptionEndDate),
            })}
          </p>
        )}
        <div className="cand-card_foot">
          <button
            className="btn--2"
            disabled={loadingPortal}
            onClick={() => {
              const handlePortalLink = async () => {
                try {
                  setLoadingPortal(true);
                  const result = await getCustomerPortalUserLink(user.id);
                  if (result?.url) window.location.href = result.url;
                } catch (err) {
                  logger.error(
                    "Erreur lors de la récupération du lien premium",
                    err,
                  );
                  toastError("common:error.header.PREMIUM_LINK_ERROR");
                  return;
                } finally {
                  setLoadingPortal(false);
                }
              };

              void handlePortalLink();
            }}
          >
            {loadingPortal
              ? "..."
              : t("accounts:premium.MANAGE_SUBSCRIPTION_BUTTON")}
          </button>
        </div>
      </div>
    </section>
  );
};

export default PremiumSection;
